// extracted by mini-css-extract-plugin
export default {"container":"cookies_container__ryUkk","content":"cookies_content__4LjUp","text":"cookies_text__bMd3z","policy":"cookies_policy__8ZwWe","button":"cookies_button__lAWNo"};